import React from 'react';
import { Router } from '@reach/router';

import AccountErrorPage from '../../features/auth/AccountErrorPage';

const ErrorAppRoutes = ({ title = 'Something bad happened', message = 'Our tech team has been notified and will investigate' }) => {
    return (
        <Router>
            <AccountErrorPage default {...{ title, message }} />
        </Router>
    );
}

export default ErrorAppRoutes;